import React from 'react';
import { isTestMode } from '~/lib/TestModeHelpers.js';

const PreviewBookingBanner = ({ form }) => {
    // Get the business ID from the form
    const businessId = form?.business_id;

    // Check if `test` is in query string
    const isTest = isTestMode();

    if (!isTest || !businessId) {
        return null;
    }

    return (
        <div className="bg-primary-100 text-center py-4">
            👀 You’re previewing your booking page:  <a href={`https://app.breely.com/business/${businessId}/calendar`} className="text-primary-700 no-underline hover:underline">Return to Dashboard ↗</a>
        </div>
    );
}

export default PreviewBookingBanner;
